module.exports = "/build/web/svg/sponsor/scania-wit.7aa819e72d375d4fa495a2e653853be1.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/scania-wit.svg
// module id = 220
// module chunks = 24